import { createFileRoute, redirect } from '@tanstack/react-router'
import VerifyEmailPage from '@/views/verify-email'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/auth/verify-email')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (!auth.user) {
      throw redirect({ to: '/auth/login' })
    }
  },
  component: VerifyEmailPage,
})